import styled from 'styled-components'

interface ContainerProps {
  id?: string
  children?: React.ReactNode
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  min-height: 400px;
  margin: 20px 0;
`

export const SearchForm = styled.form`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  max-width: 960px;
  margin-left: auto;
  margin-right: auto;
`

export const SearchInput = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`

export const SearchButton = styled.button`
  padding: 0.5rem 1rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`
export const HideParcelLabElements = styled.div`
  #parcellab-track-and-trace h1,
  #parcellab-track-and-trace > div > div > div:first-child {
    display: none !important;
  }
  #parcellab-track-and-trace > br {
    display: none !important;
  }
`
